import { Breakpoints } from '@apps/gated-2021/breakpoints';
import styled from 'styled-components';

/**
 * Styled component that defines the layout an Estimator inner view i.e.
 */
export const ContentView = styled.div`
    display: grid;
    grid-template-areas: 'form chart';
    grid-template: auto / 2fr 1fr;
    grid-gap: 92px;

    height: 100%;
    max-width: 1261px;
    margin: auto;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    @media print {
        display: flex;
        flex-direction: column;
        gap: 70px;
    }
`;
